import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { contentTypeLabels } from '@/mocks/movies';

interface PosterCardProps {
  movie: Movie;
}

export default function PosterCard({ movie }: PosterCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报 - 亚洲中文字幕在线观看`}
          title={`${movie.title} - 亚洲中文字幕在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/5 to-transparent opacity-90"></div>

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-800/85 text-white text-[11px] whitespace-nowrap">
          {movie.status}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-white">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <h3 className="font-heading font-bold text-white text-sm md:text-base truncate">{movie.title}</h3>
          <p className="text-[11px] md:text-xs text-white/75 truncate mt-0.5">
            {movie.year} · {contentTypeLabels[movie.type]} · {movie.region}
          </p>
        </div>
      </div>
    </Link>
  );
}